import React from "react";
import PropTypes from "prop-types";
import ClearIcon from "@mui/icons-material/Clear";
import { EDIT_COLUMNS } from "../../../../config/buildingColumnsConfig";

const EditBuildingRow = ({
  building,
  index,
  selectedBuilding,
  onRowClick,
  handlers,
  //handleAutoSave,
}) => {
  const isSelected =
    selectedBuilding && selectedBuilding.buildingID === building.buildingID;
  return (
    <tr
      onClick={() => onRowClick(building)}
      className={`border-t cursor-pointer ${
        isSelected ? "bg-cyan-100" : "bg-transparent"
      } ${!isSelected ? "hover:bg-cyan-50 hover:shadow-lg" : ""}`}
    >
      <td className="px-1 py-1 border border-white bg-white text-center">
        <button
          onClick={() => handlers.removeBuilding(building.buildingID)}
          className="text-gray-500 hover:text-red-500 transition duration-150"
          aria-label="Remove Building"
        >
          <ClearIcon fontSize="small" />
        </button>
      </td>
      {EDIT_COLUMNS.map((col) => (
        <td key={col.key} className="px-1 py-1 border">
          {col.type === "select" ? (
            <select
              name={col.key}
              value={building[col.key]}
              onChange={(e) =>
                handlers.handleBuildingFieldChange(
                  building.buildingID,
                  col.key,
                  e.target.value
                )
              }
              className="w-full border-0 outline-none bg-inherit"
            >
              {col.options.map(([optionKey, optionLabel]) => (
                <option key={optionKey} value={optionKey}>
                  {optionLabel}
                </option>
              ))}
            </select>
          ) : (
            <input
              type={col.type}
              name={col.key}
              value={building[col.key]}
              onChange={(e) =>
                handlers.handleBuildingFieldChange(
                  building.buildingID,
                  col.key,
                  e.target.value
                )
              }
              className="w-full border-0 outline-none bg-inherit"
            />
          )}
        </td>
      ))}
    </tr>
  );
};

EditBuildingRow.propTypes = {
  building: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  selectedBuilding: PropTypes.object,
  onRowClick: PropTypes.func.isRequired,
  handlers: PropTypes.shape({
    handleBuildingFieldChange: PropTypes.func.isRequired,
    removeBuilding: PropTypes.func.isRequired,
  }).isRequired,
  //handleAutoSave: PropTypes.func.isRequired,
};

export default EditBuildingRow;
